import { ColumnBase } from "@progress/kendo-angular-grid";
import { CommonGridColumnDataDefinition } from "dto";

export class ExternalFilterHost{
    public description: string;
    public column: ColumnBase;
    public columnDefinition: CommonGridColumnDataDefinition;      
    public filter: any;
}